import { IconProps } from '../IconsTypes'

const StoreHeaderIcon = ({ className, ...props }: IconProps) => {
  return (
    <svg
      className={`block ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M13.6667 7.33329C13.6667 10.6553 10.5807 12.6939 8.5387 14.0426L8.18538 14.2773C8.12938 14.3146 8.06469 14.3333 8.00069 14.3333C7.93669 14.3333 7.87204 14.3146 7.81604 14.2773L7.46269 14.0426C5.42069 12.6939 2.33472 10.6553 2.33472 7.33329C2.33472 4.20863 4.87672 1.66663 8.00138 1.66663C11.126 1.66663 13.6667 4.20863 13.6667 7.33329ZM7.75069 5.15198L7.24736 6.15068C7.20936 6.22601 7.13604 6.278 7.05204 6.29L5.89006 6.45536C5.67672 6.48536 5.59205 6.7426 5.74605 6.88993L6.58606 7.69137C6.64739 7.75003 6.67539 7.83461 6.66073 7.91728L6.46871 9.01331C6.42938 9.23597 6.66803 9.4059 6.87203 9.30123L7.87935 8.78332C7.95469 8.74466 8.04539 8.74466 8.12073 8.78332L9.1287 9.30188C9.3327 9.40655 9.57071 9.23727 9.53137 9.01461L9.33936 7.91728C9.32469 7.83461 9.35269 7.75003 9.41402 7.69137L10.254 6.88993C10.4087 6.7426 10.3234 6.48536 10.11 6.45536L8.94804 6.29C8.86337 6.278 8.79006 6.22601 8.75273 6.15068L8.24939 5.15198C8.14739 4.94931 7.85269 4.94931 7.75069 5.15198Z"
        fill="black"
      ></path>
    </svg>
  )
}

export default StoreHeaderIcon
